import React from 'react'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton
} from '@mui/material'
import MenuClose from 'assets/icons/MenuClose.png'
import { RoundedButton } from 'common/Button/Button'
import TextColorFontBody from 'common/Typography/TextColorFontBody'

interface ChangeItemProps {
  header: string
  body: string
}

const ChangeItem = (props: ChangeItemProps) => {
  const { header, body } = props
  return (
    <DialogContentText sx={{ marginBottom: '30px', marginLeft: '0' }}>
      <TextColorFontBody
        sx={{ fontSize: '18px', fontWeight: 500, color: '#253140' }}
      >
        {header}
      </TextColorFontBody>
      <TextColorFontBody
        sx={{
          fontSize: '16px',
          fontWeight: 500,
          color: '#253140',
          mt: '10px'
        }}
      >
        {body}
      </TextColorFontBody>
    </DialogContentText>
  )
}

const FaberConfirmCustomerUpdateDialog = ({
  handleDialogClose,
  confirmUpdateDialogOpen,
  initialValues,
  values,
  confirmChanges
}: FaberConfirmPaymentUpdateDialogProps) => {
  /* TODO: ADD LOGIC FOR ACTUALLY CONFIRMING */
  function onConfirmClick() {
    confirmChanges()
    handleDialogClose()
  }
  function onCancelClick() {
    handleDialogClose()
  }

  const headerMap = {
    paymentStatus: 'Payment Status',
    paymentID: 'Payment ID',
    remarks: 'Remarks'
  }

  return (
    <Dialog
      open={confirmUpdateDialogOpen}
      onClose={() => {
        handleDialogClose()
      }}
      fullWidth={true}
      maxWidth='sm'
    >
      <DialogTitle
        sx={{
          margin: '0',
          fontWeight: '700',
          color: 'black',
          fontSize: '21px',
          mt: '4px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Box>Changes Made</Box>
        <IconButton
          onClick={handleDialogClose}
          size='small'
          data-cy='closeDialogBtn'
          sx={{
            mr: '-10px',
            mt: '-10px'
          }}
        >
          <img
            style={{
              width: '20px',
              height: '20px'
            }}
            src={MenuClose}
          />
        </IconButton>
      </DialogTitle>
      <Divider sx={{ width: '100%' }} />
      <DialogContent>
        {Object.keys(values).map((key, index) => {
          return (
            <ChangeItem
              key={index}
              header={headerMap[key]}
              body={`${
                initialValues[key] !== '' ? initialValues[key] : '(blank)'
              } > ${values[key] !== '' ? values[key] : '(blank)'}`}
            />
          )
        })}
      </DialogContent>
      <DialogActions>
        <RoundedButton variant='filled' onClick={onCancelClick}>
          Cancel
        </RoundedButton>
        <RoundedButton variant='filled' onClick={onConfirmClick}>
          Confirm
        </RoundedButton>
      </DialogActions>
      {/* </ColorBox> */}
    </Dialog>
  )
}

interface FaberConfirmPaymentUpdateDialogProps {
  handleDialogClose
  confirmUpdateDialogOpen: boolean
  initialValues: PaymentUpdatedValues
  values: PaymentUpdatedValues
  confirmChanges: () => void
}

export interface PaymentUpdatedValues {
  paymentStatus: string
  paymentID: string
  remarks: string
}

export default FaberConfirmCustomerUpdateDialog
